import { useEffect, useState } from "react";
import { Star, Quote, PlayCircle } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/motion";
import { getTestimonials } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { getTestimonials().then(setItems).catch(() => {}); }, []);

  return (
    <>
      <Seo title="Guest Reviews | Legacy India Travel" description="Read reviews and stories from our travellers around the world who journeyed through Incredible India with Legacy India Travel." />
      <PageHero title="Guest Stories" subtitle="Real journeys, real words — from travellers who trusted us with their India adventure." image="https://images.pexels.com/photos/17397822/pexels-photo-17397822.jpeg?auto=compress&cs=tinysrgb&w=1600" crumbs={[{ label: "Reviews" }]} />

      <section className="py-16 sm:py-24 bg-[#faf8f5]">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-testid="testimonials-grid">
            {items.map((t, i) => (
              <Reveal key={t.id} delay={(i % 3) * 0.06}>
                <div className="bg-white border border-[#d4af37]/25 p-8 h-full flex flex-col">
                  <Quote className="w-9 h-9 text-[#d4af37]" strokeWidth={1.3} />
                  <p className="mt-4 font-serif italic text-xl text-[#3b1a1a] leading-relaxed flex-1">“{t.review}”</p>
                  {t.video_url && (
                    <a href={t.video_url} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#7c1d1d]"><PlayCircle className="w-4 h-4" /> Watch video</a>
                  )}
                  <div className="mt-6 pt-5 border-t border-[#d4af37]/20 flex items-center gap-4">
                    <span className="w-12 h-12 rounded-full bg-[#14523d] text-white grid place-items-center text-2xl shrink-0">{t.country_flag || "🌏"}</span>
                    <div>
                      <div className="font-serif text-lg text-[#3b1a1a]">{t.name}</div>
                      <div className="flex items-center gap-1 mt-1 text-[#d4af37]">{Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} className="w-3.5 h-3.5 fill-[#d4af37]" strokeWidth={0} />)}</div>
                      <div className="text-[11px] tracking-[0.2em] uppercase text-[#5a4b4b] mt-1">{t.country}</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          {items.length === 0 && <div className="text-center py-16 text-[#5a4b4b]">Reviews coming soon.</div>}
        </div>
      </section>
    </>
  );
}
